import React, { useEffect, useState } from "react";
import "./../HomePage/Profile/MyProfile.css";
import { useNavigate } from "react-router-dom";
import { IP } from '../internalServer';
import TicketsMain from ".";
import { Steps } from "intro.js-react";
import { ticketSteps } from "../utils/ticketSteps";


const TicketPopup = ({ handleTicketClose }) => {
    const [studentDetails, setStudentDetails] = useState();
    const [click, setClick] = useState(false)
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [ticketOpned, setTicketOpned] = useState(false);

    const [stepsEnabled, setStepsEnabled] = useState(false);
    const [initialStep, setInitialStep] = useState(0);
    const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] = useState(false);
    useEffect(() => {
        // Check if the popup has been shown before
        const hasShownPopup = localStorage.getItem("hasShownPopupQuery");
        if (!hasShownPopup) {
            // Show the steps if it hasn't been shown before
            setHomeScreenWalkThroughPopup(true);
            // Set the flag in localStorage to indicate the popup has been shown
            localStorage.setItem("hasShownPopupQuery", "true");
        }
    }, []);
    const [steps, setSteps] = useState(ticketSteps);
    const onExit = () => {
        setStepsEnabled(false);
    };

    const handleClick = () => {
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 5000);
    };
    return (
        <>
            <Steps
                enabled={stepsEnabled}
                steps={steps}
                initialStep={initialStep}
                onExit={onExit}
            />
            <div className="p-4 myprofileContaienr" style={{ width: 'calc(100% - 7%)' }}>
                {!ticketOpned &&
                    <div className="d-flex justify-content-between ">
                        <div className="d-flex justify-content-between w-100">
                            <div className="d-flex gap-4">
                                <div
                                    onClick={handleTicketClose}
                                    style={{ cursor: "pointer" }}
                                    className="d-flex align-items-center "
                                >
                                    <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                                </div>
                                <div className="HeaderTitle myFeed2">
                                    <div className="d-flex align-items-center">
                                        <span>
                                            <img style={{ width: "55px", marginRight: "20px" }} src="/images/TicketImage.jpeg" alt="img" />
                                        </span>
                                        <span>Tickets and B4S Updates</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <TicketsMain setTicketOpned={setTicketOpned} />
            </div>
        </>
    );
}

export default TicketPopup